// 账号验证
export const checktelephone = (rule, value, callback) => {
    if (!value) {
        callback(new Error('请输入您的手机号'))
    } else if (/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入11位手机号'))
    } else {
        callback()
    }
}